import { Field, FieldProps, FormikProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolButton, PoolModal, PoolTypography } from '@synergy/components';
import { fields } from '@synergy/utils';
import { useState } from 'react';

import { ChipTextField } from './chip-textfield';
import { ProductDetailOverviewFormValues } from '../models/product-detail-overview-form-values';

export const ProductDetailOverviewSectionSearchTerms = () => {
    const [showModal, setShowModal] = useState(false);
    const fieldNames = fields<ProductDetailOverviewFormValues>();

    const handleValueChanged = (form: FormikProps<unknown>, fieldName: string) => (values: string[]) => {
        if (values.length === 0) {
            setShowModal(true);
        } else {
            form.setFieldValue(fieldName, values);
        }
    };

    const handleResetConfirm = (form: FormikProps<unknown>, fieldName: string) => () => {
        form.setFieldValue(fieldName, []);
        setShowModal(false);
    };

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.product.detail.searchTerms" />
            <Grid container spacing={2}>
                <Grid item={true} xs={12}>
                    <Field name={fieldNames.searchTerms}>
                        {({ form, field }: FieldProps<string[]>) => (
                            <>
                                <ChipTextField
                                    {...field}
                                    limitTags={6}
                                    onChange={handleValueChanged(form, field.name)}
                                    placeholderId="app.label.searchTerms"
                                />
                                <PoolModal
                                    isVisible={showModal}
                                    title={<FormattedMessage id="app.product.detail.searchTerms.delete" />}
                                    handleClose={() => setShowModal(false)}
                                    actionChildren={[
                                        <PoolButton
                                            key="1"
                                            onClick={() => setShowModal(false)}
                                            styleType="firstLevel"
                                            variant="text"
                                        >
                                            <FormattedMessage id="app.common.cancel" />
                                        </PoolButton>,
                                        <PoolButton
                                            key="2"
                                            onClick={handleResetConfirm(form, field.name)}
                                            styleType="firstLevel"
                                            color="secondary"
                                        >
                                            <FormattedMessage id="app.common.delete" />
                                        </PoolButton>,
                                    ]}
                                    hasModalTypography={true}
                                >
                                    <PoolTypography id="app.product.detail.searchTerms.deleteText" />
                                </PoolModal>
                            </>
                        )}
                    </Field>
                </Grid>
            </Grid>
        </>
    );
};
